import createApiClient from './client';
const request = createApiClient();
export const civicApi = {
    tenant: () => request('/civic/tenant'),
    actor: () => request('/civic/me'),
    jurisdictions: (params = {}) => {
        const search = new URLSearchParams();
        if (params.parentId)
            search.set('parentId', params.parentId);
        if (params.levelKey)
            search.set('levelKey', params.levelKey);
        const suffix = search.toString();
        return request(`/civic/jurisdictions${suffix ? `?${suffix}` : ''}`);
    },
    overview: () => request('/civic/overview'),
    list: (params = {}) => {
        const search = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (value)
                search.set(key, value);
        });
        const suffix = search.toString();
        return request(`/civic/records${suffix ? `?${suffix}` : ''}`);
    },
    entry: (id) => request(`/civic/records/${encodeURIComponent(id)}`),
    responses: (id) => request(`/civic/records/${encodeURIComponent(id)}/responses`),
    submitResponse: (id, payload) => request(`/civic/records/${encodeURIComponent(id)}/responses`, { method: 'POST', body: JSON.stringify(payload) }),
    reviewResponse: (id, action, reason) => request(`/civic/responses/${encodeURIComponent(id)}/review`, { method: 'POST', body: JSON.stringify({ action, reason }) }),
    create: (payload) => request('/civic/records', {
        method: 'POST',
        body: JSON.stringify(payload),
    }),
    update: (id, payload) => request(`/civic/records/${encodeURIComponent(id)}`, {
        method: 'PUT',
        body: JSON.stringify(payload),
    }),
    transition: (id, payload) => request(`/civic/records/${encodeURIComponent(id)}/transition`, {
        method: 'POST',
        body: JSON.stringify(payload),
    }),
    compareCandidates: (ids) => request(`/civic/candidates/compare?ids=${encodeURIComponent(ids.join(','))}`),
    links: (id) => request(`/civic/records/${encodeURIComponent(id)}/links`),
    addLink: (id, payload) => request(`/civic/records/${encodeURIComponent(id)}/links`, {
        method: 'POST',
        body: JSON.stringify(payload),
    }),
    removeLink: (recordId, linkId) => request(`/civic/records/${encodeURIComponent(recordId)}/links/${encodeURIComponent(linkId)}`, {
        method: 'DELETE',
    }),
    platformTenants: () => request('/civic/platform/tenants'),
    bootstrapTenants: () => request('/civic/platform/tenants/bootstrap', { method: 'POST' }),
    createTenant: (payload) => request('/civic/platform/tenants', {
        method: 'POST', body: JSON.stringify(payload),
    }),
    updateTenant: (tenantId, payload) => request(`/civic/platform/tenants/${encodeURIComponent(tenantId)}`, {
        method: 'PUT', body: JSON.stringify(payload),
    }),
    previewTenant: (payload) => request('/civic/platform/tenants/preview', {
        method: 'POST', body: JSON.stringify(payload),
    }),
    tenantReadiness: (tenantId) => request(`/civic/platform/tenants/${encodeURIComponent(tenantId)}/readiness`),
    exportTenant: (tenantId) => request(`/civic/platform/tenants/${encodeURIComponent(tenantId)}/export`),
    provisionTenantMembership: (tenantId, userId, payload) => request(`/civic/platform/tenants/${encodeURIComponent(tenantId)}/memberships/${encodeURIComponent(userId)}`, {
        method: 'PUT', body: JSON.stringify(payload),
    }),
    adminMemberships: () => request('/civic/admin/memberships'),
    searchMembershipCandidates: (query) => request(`/civic/admin/membership-candidates?q=${encodeURIComponent(query)}`),
    updateMembership: (userId, payload) => request(`/civic/admin/memberships/${encodeURIComponent(userId)}`, {
        method: 'PUT', body: JSON.stringify(payload),
    }),
    createJurisdiction: (payload) => request('/civic/admin/jurisdictions', {
        method: 'POST', body: JSON.stringify(payload),
    }),
    updateJurisdiction: (id, payload) => request(`/civic/admin/jurisdictions/${encodeURIComponent(id)}`, {
        method: 'PUT', body: JSON.stringify(payload),
    }),
    deactivateJurisdiction: (id) => request(`/civic/admin/jurisdictions/${encodeURIComponent(id)}`, {
        method: 'DELETE',
    }),
};
export default civicApi;
